import Vue from 'vue';
import VeeValidate from 'vee-validate';
import smoothscroll from 'smoothscroll-polyfill';

import App from './App.vue';
import router from './router';
import store from './store';
import { dictionary } from '@/common/utils/dictionary';

smoothscroll.polyfill();

Vue.config.productionTip = false;
Vue.use(VeeValidate, {
  classes: true,
  dictionary: dictionary,
  events: 'input|blur'
});

new Vue({
  store,
  router,
  el: '#app',
  components: { App },
  render: h => h(App)
});
